import { jsx } from "react/jsx-runtime";
import { PreviewCloseOutlined, PreviewOpenOutlined } from "@wepie/weet-icons";
import { forwardRef } from "react";
import { Input } from "antd";
import { overrideAllowClearProp, overrideCountProp, overrideShowCountProp } from "./utils.js";
import { rootClass } from "./constant.js";
import classnames from "classnames";
const defaultIconRender = (visible)=>visible ? /*#__PURE__*/ jsx(PreviewOpenOutlined, {}) : /*#__PURE__*/ jsx(PreviewCloseOutlined, {});
const InputPassword = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { allowClear: inputAllowClear, size, iconRender = defaultIconRender, showCount: inputShowCount, count: inputCountConfig, ...restProps } = props;
    const allowClear = overrideAllowClearProp(inputAllowClear);
    const showCount = overrideShowCountProp(inputShowCount);
    const count = overrideCountProp(inputCountConfig);
    return /*#__PURE__*/ jsx(Input.Password, {
        ...restProps,
        size: size,
        iconRender: iconRender,
        allowClear: allowClear,
        showCount: showCount,
        count: count,
        ref: ref,
        className: classnames(rootClass, restProps.className)
    });
});
export { InputPassword };
